module.exports = "<div class=\"main-view\" #mainView>\n    <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-view/main-view.component.html
// module id = ./src/app/main-view/main-view.component.html
// module chunks = main